
import {getken} from '@/api/getToken';
import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import Checklist from 'vux/src/components/checklist/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data(){
return{
noMsgShow:false,
dialogshow:false,
cancelpromptMessage:false,
inputTxt:[],
projectList:[],
resonList: [{key: '1', value: '001 value'}, {key: '2', value: '002 value'}, {key: '3', value: '003 value'}],
}
},
directives: {
TransferDom
},
components: {
Checklist ,Group ,Radio,Toast ,XInput ,XDialog,XButton, XHeader
},
methods:{
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
this.getProject();
this.cancelReason();
}).catch(error => {

})

},
cancelReason(){
this.resonList = [];
fetch('get',urlConfig.surgicalAppointGetCancelReson).then(response => {
console.log(response)
for(let i =0;i<response.length;i++){
this.resonList.push({value:response[i].szdCmc,key:response[i].szdDm});
}

}).catch(error => {
});
},
getProject(){
fetch('get',urlConfig.surgicalAppointGetList+ '?personInfoId=' +this.personInfoId).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
if(response.length !=0){
this.noMsgShow = false;
}else {
this.noMsgShow = true;
}
this.projectList = response;

}).catch(error => {
})
},
cancel () {
if(this.inputTxt.length !=0){  //取消预约
this.dialogshow = false;
this.inputTxt = [];
this.parmaData = new URLSearchParams();
this.parmaData.append('id',this.id);
this.parmaData.append('cancelReasonDm',this.inputTxt.toString());
fetch('post',urlConfig.surgicalAppointCancel,this.parmaData).then(response => {
promptMessage('提示','取消成功！');
this.getProject();
}).catch(error => {

})
}else{
this.cancelpromptMessage =true;
}
},
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
getken(this.getUserId);
}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/surgicalAppointment.vue